import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, FocusRingVariants, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import FullscreenBackground from '@/components/image/FullscreenBackground';
import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	padding: 80px 0 120px;
	position: relative;
	margin: 0 auto;
	max-width: 1440px;
	text-align: center;

	${minWidth('tablet')} {
		padding: 60px 0 135px;
	}

	${minWidth('desktopLarge')} {
		padding: 160px 0;
	}
`;

export const Background = styled(FullscreenBackground)``;

export const Grid = styled(GridWrapper)`
	grid-gap: 0;
`;

export const Heading = styled.h2`
	color: ${palette('gray6')};
	${fontWeight(FontWeights.Light)};

	&:last-of-type {
		margin-bottom: 36px;
	}
`;

export const CtaButton = styled(Button).attrs({
	focusRingVariant: FocusRingVariants.Dark,
})`
	margin: 0 auto;
`;
